var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5H18C7.14 45.5 2.5 40.86 2.5 30V18C2.5 7.14 7.14 2.5 18 2.5H30C40.86 2.5 45.5 7.14 45.5 18V30C45.5 40.86 40.86 45.5 30 45.5ZM18 5.5C8.78 5.5 5.5 8.78 5.5 18V30C5.5 39.22 8.78 42.5 18 42.5H30C39.22 42.5 42.5 39.22 42.5 30V18C42.5 8.78 39.22 5.5 30 5.5H18Z",
    fill: "#0D0101",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 30.5184C23.6189 30.5184 23.2389 30.3784 22.9389 30.0784L16.9389 24.0784C16.3589 23.4984 16.3589 22.5384 16.9389 21.9584C17.5189 21.3784 18.4789 21.3784 19.0589 21.9584L23.9989 26.8984L28.9389 21.9584C29.5189 21.3784 30.4789 21.3784 31.0589 21.9584C31.6389 22.5384 31.6389 23.4984 31.0589 24.0784L25.0589 30.0784C24.7589 30.3784 24.3789 30.5184 23.9989 30.5184Z",
    fill: "#0D0101",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30.5234C23.18 30.5234 22.5 29.8434 22.5 29.0234V13.0234C22.5 12.2034 23.18 11.5234 24 11.5234C24.82 11.5234 25.5 12.2034 25.5 13.0234V29.0234C25.5 29.8634 24.82 30.5234 24 30.5234Z",
    fill: "#0D0101",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0009 36.4603C19.7809 36.4603 15.5409 35.7803 11.5209 34.4403C10.7409 34.1803 10.3209 33.3203 10.5809 32.5403C10.8409 31.7603 11.6809 31.3203 12.4809 31.6003C19.9209 34.0803 28.1009 34.0803 35.5409 31.6003C36.3209 31.3403 37.1809 31.7603 37.4409 32.5403C37.7009 33.3203 37.2809 34.1803 36.5009 34.4403C32.4609 35.8003 28.2209 36.4603 24.0009 36.4603Z",
    fill: "#0D0101",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDownload);
export default __webpack_public_path__ + "static/media/imageDownload.d0a3d74aad68d60f7639c59d94818499.svg";
export { ForwardRef as ReactComponent };